import { render, staticRenderFns } from "./tabbar3.7.vue?vue&type=template&id=3bfd229e&scoped=true"
import script from "./tabbar3.7.vue?vue&type=script&lang=js"
export * from "./tabbar3.7.vue?vue&type=script&lang=js"
import style0 from "./tabbar3.7.vue?vue&type=style&index=0&id=3bfd229e&prod&lang=css"
import style1 from "./tabbar3.7.vue?vue&type=style&index=1&id=3bfd229e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfd229e",
  null
  
)

export default component.exports